<svg xmlns="http://www.w3.org/2000/svg"  [attr.width]="width" height="60px" [attr.viewBox]="viewbox" [ngClass]="{negative:negative}">
  <g class="squeareTotal" [ngClass]='checkCLass()'>
    <!-- <rect width="100" height="100" /> -->
    @if (type == 'number') {
      <g>
        <text class="number" [attr.x]="50" y="30">
          @if (validValue <= 999) {
            <ng-container>
              <tspan>{{validValue | number:'1.0-0'}}</tspan>
            </ng-container>
          }
          @if (validValue > 999) {
            <ng-container>
              <tspan>{{(getRoofValue(value)) | number:'1.0-0'}}</tspan>
              <tspan class="percent">,{{get1000Value(value) | number:'3.0-0'}}</tspan>
            </ng-container>
          }
        </text>
      </g>
    }
    @if (type == 'currency') {
      <g>
        @if (!showDecimals) {
          <text class="number" [attr.x]="50" y="30">
            <tspan>${{validValue | number:'1.0-0'}}</tspan>
          </text>
        }
        @if (showDecimals) {
          <text class="number" [attr.x]="50" y="30">
            <tspan>${{validValue}}</tspan>
          </text>
        }
      </g>
    }
    @if (type == 'pages') {
      <g>
        <text class="number" [attr.x]="50" y="30">
          @if (getInteger(validValue) < 1000) {
            <ng-container>
              <tspan>{{getInteger(validValue)}}</tspan>
              <tspan class="percent">{{getFraction(validValue)}}</tspan>
            </ng-container>
          }
          @if (getInteger(validValue) >= 1000) {
            <ng-container>
              <tspan>{{(getRoofValue(validValue)) | number:'1.0-0'}}</tspan>
              <tspan>,{{get1000Value(validValue) | number:'3.0-0'}}  </tspan>
              <tspan class="percent">{{getFraction(validValue)}}</tspan>
            </ng-container>
          }
        </text>
      </g>
    }
    <!-- string -->
    @if (type == 'string') {
      <g>
        <text class="number" [attr.x]="50" y="30">
          <tspan>{{validValue}}</tspan>
        </text>
      </g>
    }
    @if (type == 'minutes') {
      <g>
        <text class="number" [attr.x]="50" y="30">
          <tspan>{{validValue}}</tspan>
          @if (value > -6000 && value < 6000) {
            <tspan  class="percent">{{getSegValue(value)}}</tspan>
          }
        </text>
      </g>
    }
    @if (type == 'percent') {
      <g>
        <text class="number" [attr.x]="50" y="30">
          <tspan>{{value}}</tspan>
          <tspan class="percent">%</tspan>
        </text>
      </g>
    }
    <switch>
      <foreignObject [attr.x]="15" y="35" width="70" height="30">
        <label class="label" xmlns="http://www.w3.org/1999/xhtml">{{label}}</label>
      </foreignObject>
    </switch>
    <!-- <text class="label" [attr.x]="50" y="80">{{label}}</text> -->
  </g>
</svg>
